import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

export interface PageChangedEvent {
  itemsPerPage: number;
  page: number;
  navigatedTo?: string;
}
@Component({
  selector: 'cigna-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input()
  set currentPage(currentPage: number) {
    this._page = currentPage > 0 ? currentPage : 1;
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() boundaryLinks = false;
  /** if false first and last buttons will be hidden */

  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() directionLinks = true;
  /** if false previous and next buttons will be hidden */

  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() useChevron = false;

  @Input() firstText = 'First';
  @Input() previousText = 'Previous';
  @Input() nextText = 'Next';
  @Input() lastText = 'Last';

  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() disabled: boolean;
  /** if true pagination component will be disabled */

  @Input()
  set itemsPerPage(v: number) {
    this._itemsPerPage = v;
    this.totalPages = this.calculateTotalPages();
  }
  get itemsPerPage(): number {
    return this._itemsPerPage;
  }

  @Input()
  set totalItems(v: number) {
    this._totalItems = v;
    this.totalPages = this.calculateTotalPages();
  }
  get totalItems(): number {
    return this._totalItems;
  }

  @Output() numPages = new EventEmitter<number>();
  /** fired when total pages count changes, $event:number equals to total pages count */

  @Output() pageChanged = new EventEmitter<PageChangedEvent>();
  /** fired when page was changed, emits object with current page index, number of items per page, and page navigated to */

  set totalPages(v: number) {
    this._totalPages = v;
    this.numPages.emit(v);
    if (this._inited) {
      this.selectPage(this.page);
    }
  }

  get totalPages(): number {
    return this._totalPages;
  }

  set page(value: number) {
    const previous = this.page;
    this._page = value > this.totalPages ? this.totalPages : value || 1;
    this._changeDetection.markForCheck();

    if (previous === this._page || typeof previous === 'undefined') {
      return;
    }

    this.pageChanged.emit({
      page: this._page,
      itemsPerPage: this.itemsPerPage,
      navigatedTo: this.navigatedTo,
    });
  }

  get page(): number {
    return this._page;
  }

  navigatedTo: string;

  protected _itemsPerPage = 10;
  protected _totalItems: number;
  protected _totalPages: number;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected _inited = false;
  protected _page: number;

  constructor(private _changeDetection: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.totalPages = this.calculateTotalPages();
    this._inited = true;
  }

  writeValue(value: number): void {
    this.page = value;
  }

  noPrevious(): boolean {
    return this.page === 1;
  }

  noNext(): boolean {
    return this.page === this.totalPages;
  }

  selectPage(page: number, event?: Event, navigatedTo?: string): void {
    if (event?.target) {
      (event.target as HTMLElement).blur();
    }
    this.navigatedTo = navigatedTo ? navigatedTo : '';
    this.writeValue(page);
  }

  protected calculateTotalPages(): number {
    const totalPages = this.itemsPerPage
      ? Math.ceil(this.totalItems / this.itemsPerPage)
      : 1;

    return Math.max(totalPages, 1);
  }
}
